"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebExtensionMessage = exports.FromContentScriptToWebMessage = exports.FromWebToContentScriptMessage = void 0;
// ---------------------------------------------
// web -> content script
// ---------------------------------------------
var FromWebToContentScriptMessage;
(function (FromWebToContentScriptMessage) {
    FromWebToContentScriptMessage["REFETCH_STATES"] = "refetch_states";
    FromWebToContentScriptMessage["EXECUTE_TX"] = "execute_tx";
    FromWebToContentScriptMessage["REQUEST_APPROVAL"] = "request_approval";
})(FromWebToContentScriptMessage = exports.FromWebToContentScriptMessage || (exports.FromWebToContentScriptMessage = {}));
// ---------------------------------------------
// content script -> web
// ---------------------------------------------
var FromContentScriptToWebMessage;
(function (FromContentScriptToWebMessage) {
    FromContentScriptToWebMessage["STATES_UPDATED"] = "states_updated";
    FromContentScriptToWebMessage["TX_RESPONSE"] = "tx_response";
})(FromContentScriptToWebMessage = exports.FromContentScriptToWebMessage || (exports.FromContentScriptToWebMessage = {}));
function isWebExtensionMessage(value) {
    if (!value || typeof value !== 'object' || !('type' in (value !== null && value !== void 0 ? value : {}))) {
        return false;
    }
    const msg = value;
    switch (msg.type) {
        // web -> content script
        case FromWebToContentScriptMessage.REFETCH_STATES:
            return true;
        case FromWebToContentScriptMessage.EXECUTE_TX:
            return typeof msg.id === 'number' && !!msg.payload;
        case FromWebToContentScriptMessage.REQUEST_APPROVAL:
            return true;
        // content script -> web
        case FromContentScriptToWebMessage.STATES_UPDATED:
            return !!msg.payload;
        case FromContentScriptToWebMessage.TX_RESPONSE:
            return typeof msg.id === 'number' && !!msg.payload;
        default:
            return false;
    }
}
exports.isWebExtensionMessage = isWebExtensionMessage;
//# sourceMappingURL=webapp-contentScripts-messages.js.map